import apiClient from '@/lib/apiClient';
import { ProductInfo } from '@/lib/sales-metrics';
import { ApiResponse } from '@/types';

export const productsService = {
  getCatalog: async (): Promise<ProductInfo[]> => {
    const { data } = await apiClient.get<ApiResponse<ProductInfo[]>>('/products');
    return data.data ?? [];
  },
};
